module.exports = __webpack_public_path__ + "img/3.a363de9f.png";